import React from 'react';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import type { User } from 'auth';
import { areFeatureFlagsEnabled, getProviderConfig } from './config';
import { PassThroughProvider } from './passThroughProvider';

type LDProvider = React.FunctionComponent<{ children: React.ReactNode }>;

export const useLDProvider = (user: User): LDProvider | undefined => {
  const { userAccountId } = user ?? {};

  const [ldProvider, setLDProvider] = React.useState<LDProvider>();

  React.useEffect(() => {
    if (userAccountId && areFeatureFlagsEnabled()) {
      // guard against component unmount during asyncWithLDProvider resolution
      let isMounted = true;
      const providerConfig = getProviderConfig(user);
      asyncWithLDProvider(providerConfig)
        .then((component) => {
          if (isMounted) {
            setLDProvider(() => component);
          }
        })
        .catch(() => {
          // Degrade to rendering children without a provider so flag reads fall
          // back to their defaults instead of leaving the subtree stuck on a
          // loading spinner.
          if (isMounted) {
            setLDProvider(() => PassThroughProvider);
          }
        });
      return (): void => {
        isMounted = false;
      };
    }
    return undefined;
  }, [userAccountId]);

  return ldProvider;
};
